{
	"PaginatedList_Search": "Search",
	"PaginatedList_Search_NoResults": "No extensions matching that search were found",
	"NAME": "PaginatedList"
}